import styled from "styled-components"
import Wrapper from "./Home/Wrappe";
import SocialMedia from "./SocialMedia";


const Contactdiv  = styled.div`

  margin-top: 100px;
  width: 100%;
  
  
  & > p{
        font-size: 20px;
  }
  & > h1:hover{
      color: #F0064C;

  }



  .contacttext{
    display: flex;
    
}

.contacttext > div{

    padding: 0px;
    margin-right: 20px;
    
  }
  
  
  

.flexdiv{
    width: 100%;
    display: flex;
    justify-content: space-evenly;
  }

 
  @media (max-width:600px){
    .flexdiv{
    display: flex;
    font-size: 15px;
    flex-direction:column;
    justify-content: space-evenly;

    align-items: center;
    justify-content: center;
  }
  h3 ~h5{
    font-size: 15px;
  }
}


`;
const Button = styled.button`

  border-radius: 50px;
  width: 70px;
  height: 70px;
    outline: none;
  font-size: 40px;
  margin: 30px;


  &:hover{
    box-shadow: 0 4px 5px 3px #343e47 !important;
      color: black;
  }


  
`;
 function Contect(){
    const onHandleClick = (l)=>{
        window.open(l, "_blank")
      }
    return ( <Wrapper>
        <div id="contact">

        <Contactdiv >
    
         
              <h1>Get in Touch</h1>
              <p>
                {" "}
                Whether you want to get in touch, or talk about a project
                collaboration.
                <br />
                <strong>Feel free to connect with me</strong>
              </p>
       
          <div className="flexdiv">

            <div className="contacttext">
                    <div><h3><i class="bi bi-geo-alt-fill"></i></h3>
                    <h5>Delhi, India</h5>
                    </div>
                    <div><h3><i class="bi bi-envelope-fill"></i></h3> <h5>ritikadvice@gmail.com</h5></div>
                    
                    <div>
                        <h3><i class="bi bi-telephone-fill"></i></h3>
                        <h5>9643943996</h5>
                    </div>
                </div>
          <SocialMedia />
          </div>
     
        
                {/* <div>
                    <h3>Follow me!</h3>
                    <Button onClick={()=>{
      onHandleClick(`https://github.com/codewithritik/`)}}>
    <i class="bi bi-github"></i>

                </Button>
                <Button onClick={()=>{
                onHandleClick(`https://www.linkedin.com/in/ritik85/`) }}>
            <i class="bi bi-linkedin"></i>
                    
                </Button>
                <Button onClick={()=>{
                onHandleClick(`https://medium.com/@ritikadvice`) }}>
           <i class="bi bi-medium"></i>
                    
                </Button>
                </div> */}
          
        </Contactdiv>
            </div>
       
    </Wrapper>
        

    )
}

export default Contect